module.exports = __webpack_public_path__ + "page_2_bc.96fcbf10.png";